import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    //  justifyContent: 'space-between',
    // gap: '4px',
    '& label': {
      fontFamily: 'Inter, sans-serif',
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main
    }
  }
}))
